import { Component } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'donation-website';

  ngAfterContentInit () {
    alert(
      'For better experience, Please make sure that you are using the latest version of your web browser'
    )
  }
}
